import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ClubPaymentsStore } from './club-payments';
import { DataInit } from './data-init';
import { ADMIN_TERMS_ROUTE } from './landing';

/**
 * The wizard's own loader: hold activation until the store has answered,
 * so the page reads status/club synchronously (the accountLoadedGuard
 * shape). No diverting here - the page IS the destination (the banner
 * links back to it for action_needed too), and it offers /admin itself.
 */
export const clubPaymentsLoadedGuard: CanActivateFn = async () => {
  const onboarding = inject(ClubPaymentsStore);
  await inject(DataInit).whenReady();
  await onboarding.whenLoaded();
  return true;
};


/**
 * TERMS BEFORE THE ADMIN AREA. Running a club on Huddle is done under
 * Huddle's administrator terms, so every /admin route diverts to the
 * terms page until the version currently in force is accepted - one
 * acceptance, then never seen again (acceptance at sign-up is the
 * planned home; this guard is the floor under it).
 *
 * Sits on the /admin mount as canActivate AND canActivateChild, so deep
 * links divert the same as the front door. The server still refuses the
 * money Callables on its own check - this spares the round trip, it is
 * not the lock.
 */
export const adminTermsGuard: CanActivateFn = async () => {
  const onboarding = inject(ClubPaymentsStore);
  const router = inject(Router);
  await inject(DataInit).whenReady();
  await onboarding.whenLoaded();
  return onboarding.termsAccepted() ? true : router.parseUrl(ADMIN_TERMS_ROUTE);
};
